import { shallowEqual, useSelector } from 'react-redux';

import { getClassroomCourseVersionHashKey } from '@containers/entities/helpers';

const useCourseVersion = () => {
  /**
   * Store
   */
  const selectedClass = useSelector(state => state.UPFAssignReducer.selectedClass, shallowEqual);
  const selectedCourseOption = useSelector(state => state.UPFAssignReducer.selectedCourseOption, shallowEqual);
  const genericCourses = useSelector(state => state.UPFAssignReducer.genericCourses, shallowEqual);
  const lockedCourseVersions = useSelector(state => state.entitiesReducer.lockedCourseVersions);

  /**
   * Local variables
   */
  const { id: genericCourseId, version: genericCourseVersion } = genericCourses || {}
  const { value: classroomId } = selectedClass || {};
  const { value: courseId } = selectedCourseOption || {};
  const courseVersion = genericCourseId === Number(courseId) ? genericCourseVersion : null

  const lockedCourseVersionHashKey = getClassroomCourseVersionHashKey({ classroomId, courseId });

  const lockedCourseVersion = lockedCourseVersions[lockedCourseVersionHashKey];

  const selectedCourseVersion = lockedCourseVersion?.version || courseVersion;

  return {
    selectedClassroomId: classroomId,
    selectedCourseId: courseId,
    selectedCourseVersion
  };
};

export default useCourseVersion;
